import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { COLOR } from '@src/styles/color';

const StyledNeedsFormWrap = styled('div')`
  width: 60%;
  display: flex;
  flex-direction: column;
  gap: 31px;
  height: 100%;
  .more-info-outside {
    display: block;
  }
  .more-info-inside {
    display: none !important;
  }
  @media (max-width: 768px) {
    width: 100%;
    gap: 0px;
    .need-form-title {
      margin-bottom: 8px;
    }
    .more-info-inside {
      display: flex !important;
    }
    .more-info-outside {
      display: none !important;
    }
    .need-form-content-wrap {
      padding: 0 24px 0 8px;
    }
  }
`;

const StyledNeedForm = styled('div')`
  display: flex;
  align-items: center;
  max-height: 94px;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  .need-form-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
    flex: 60%;
    @media (max-width: 768px) {
      width: 100%;
    }
  }
  .need-form-data {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
    flex: 25%;

    @media (max-width: 1024px) {
      width: 100%;
      flex: 50%;
    }

    @media (max-width: 768px) {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      gap: 8px;
      .need-form-data-text {
        width: max-content !important;
        text-align: left !important;
        font-size: 24px !important;
        &.need-form-data-text-time {
          width: 34px !important;
        }
        &.need-form-data-text-word {
          width: 80px !important;
        }
      }
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 0px;
    margin-bottom: 0px;
    padding: 8px 0px;
  }
`;

const StyledSlider = styled('div')`
  width: 100%;
  padding: 24px 0px;
  margin-top: 16px;

  @media (max-width: 768px) {
    padding: 0px;
    margin-top: 0px;
    .slider-mui {
      padding: 8px 0px !important;
    }
  }
`;

const OptionWrapper = styled(Box)`
  background: ${COLOR.white};
  border: 1px solid ${COLOR.errorHover};
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
  @media (max-width: 768px) {
    .group-option-title {
      font-size: 14px;
    }
    .group-option-description {
      font-size: 12px;
      margin-top: 4px;
    }
  }
`;

const OptionRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  minHeight: 40,
}));

const LabelGroup = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const StyledCustomThumb = styled('span')({
  width: 12,
  height: 12,
  color: '#fff',
  background: '#fff',
  transform: 'translateX(-1px) translateY(-50%)',
  top: '50%',
  zIndex: 200,
  boxShadow: '0px 3px 8px 0px rgba(0, 122, 255, 0.48)',
  position: 'absolute',
  borderRadius: '50%',
  outline: 'none',
  cursor: 'pointer',
  '&::before': {
    content: "''",
    position: 'absolute',
    width: 8,
    height: 8,
    background: 'linear-gradient(207deg, #007AFF 2.76%, #1A37E1 80.69%)',
    zIndex: 201,
    borderRadius: '50%',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    pointerEvents: 'none',
  },
});

// CustomTrack.js
export const StyledCustomTrack = styled('span')({
  height: 4,
  backgroundColor: 'rgba(0, 122, 255, 0.8)',
  opacity: 1,
  border: 'none',
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  borderRadius: 2,
});

export {
  StyledNeedForm,
  StyledSlider,
  OptionWrapper,
  OptionRow,
  LabelGroup,
  StyledNeedsFormWrap,
};
